import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayerControlService } from './layer-control.service';
import { FlcControlLayer } from '../flc-control-layer.model';
import { AreaGroupType } from 'src/app/server-api/models';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-layer-control',
  templateUrl: './layer-control.component.html',
  styleUrls: ['./layer-control.component.css']
})
export class LayerControlComponent implements  OnInit, OnDestroy {

  layers: FlcControlLayer[] = [];
  selectedAreaGroupType: AreaGroupType[] = [] ;
  @Output() preSelectedAreaGroupType: String[] = [];
  defaultStressGroup: string = environment.default_stress_group.replace('GROUP_', '');
  
  subscription: Subscription;
  
  constructor(private layerService: LayerControlService
    ) {
    }
    ngOnInit(): void {
      console.log("on init ");
      this.layers = this.layerService.getLayers();
    }

  setVisible(layer: FlcControlLayer, visible: boolean){
    let legendSetVisible = visible;
    this.layers.forEach((l) =>
    {
      let currentShowLegend = l.showLegend;
      if (l.id !== layer.id && l.visible)
      { 
        l.showLegend = !visible && !legendSetVisible ? l.colorMap && l.colorMap.length > 10 ? true : false : false;
        if (l.showLegend) legendSetVisible = true;
      }  
      
      if (currentShowLegend !== l.showLegend)
      {
        this.layerService.changeLayerState(l);
      }
      
      if (l.selectedDropdown && l.selectedDropdown.length > 2)
      {
        this.preSelectedAreaGroupType[0] = l.selectedDropdown.replace('GROUP_', '');
      }
      else this.preSelectedAreaGroupType[0] = environment.default_stress_group.replace('GROUP_', '');

      layer.visible = visible;
      layer.showLegend = layer.colorMap && visible ? true : false;
      this.layerService.changeLayerState(layer);
    });
       
  }

  onChange(layer: FlcControlLayer)
  {
    this.layerService.changeLayerState(layer);
  }

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  setSelectedAreaGroupType(types: string[], layer: FlcControlLayer)
  {
    if (layer.showDropDown)
    {
      types.length > 0 ? layer.selectedDropdown = 'GROUP_' + types[0] : layer.selectedDropdown = null;
      this.layerService.changeLayerState(layer);
    }
  }
}
